<template>
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <router-link to="/instruction"  tag="button">
    <v-btn
            class="mr-2"
            large
            color="dark"
            v-bind="attrs" v-on="on"
            >
            <span class = "font-weight-black text-h5">Tutorial</span>
    </v-btn>
    </router-link>
    </template>
    <span style="font-size:100%">Click to View the Tutorial</span>
    </v-tooltip>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <v-btn
            class="ma-2"
            large
            fab
            color="dark"
            v-bind="attrs" v-on="on"
            @click="view_statistics"
            >
            <span class = "font-weight-black text-h5">{{count_labeled_graph}}</span>
    </v-btn>
    </template>
    <span style="font-size:100%">Click to View User Statistics</span>
    </v-tooltip>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <router-link to="/" tag="button">
    <v-btn
            class="ma-2"
            large
            color="error"
            v-bind="attrs" v-on="on"
            >
            <v-icon>mdi-exit-to-app</v-icon>
            <span class="ml-2 font-weight-bold">Quit</span>
    </v-btn>
    </router-link>
    </template>
    <span style="font-size:100%">Quit and Return to Home Page</span>
    </v-tooltip>
    <div v-if=dialog>
     <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="dialog"
      >        
        <v-card>
          <v-toolbar dark>Statistics</v-toolbar>
          <div class="text-h5 pa-5">You have labeled <span class = "font-weight-black">{{count_labeled_graph}}</span> graphs in total.</div>
          <div v-if=avg_spent class="text-h5 pa-5">You spent <span class = "font-weight-black">{{avg_spent}}</span> seconds per graph on average.</div>
          <div v-if=is_admin>
          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by one person</div>        
          <v-progress-linear
              v-bind:value = "label_once_perc"
              height = "25"
              color = "red lighten-2"
            >  
            <strong>{{label_once_perc}}%</strong>
          </v-progress-linear>
          
          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by two people</div>        
          <v-progress-linear
              v-bind:value = "label_twice_perc"
              height = "25"
              color="teal lighten-2"
            >  
            <strong>{{label_twice_perc}}%</strong>
          </v-progress-linear>

          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by three people</div>        
          <v-progress-linear
              v-bind:value = "label_thrice_perc"
              height = "25"
              color = "purple lighten-3"
            >  
            <strong>{{label_thrice_perc}}%</strong>
          </v-progress-linear>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="dark" text x-large rounded outlined @click="dialog=false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
      <div v-if=congrat_dialog>
      <v-dialog v-model="congrat_dialog" max-width="600" transition="dialog-top-transition">                    
      <v-card>
      <v-toolbar dark> Thank You </v-toolbar>
      <v-card-text class= "text-h5 pa-5">Good job! You have labeled <span class = "font-weight-black">{{count_labeled_graph}}</span> graphs.</v-card-text>
      <v-card-text class= "text-h5 pa-5">You have labeled more graphs than <span class = "font-weight-black">{{rank}}</span> % of users.</v-card-text>
      <v-card-text class= "text-h5 pa-5 pb-10">Please keep up the great work!</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="dark" text x-large rounded outlined @click="congrat_dialog=false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
    </v-app-bar>
    <v-main>
<div>
<div class="text-center mb-6">
  <h2>Please answer the following questions about this graph:</h2>
</div>

<!-- Graph Image Display -->
<v-row class="mb-4">
  <v-col cols="12" class="text-center">
    <v-card class="mx-auto" max-width="600">
      <v-img
        :src="graph_image_url"
        aspect-ratio="1.5"
        class="grey lighten-2"
        height="400"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-card>
  </v-col>
</v-row>

<!-- Questions Section -->
<v-row>
  <v-col cols="12">
    <v-card class="mx-auto" max-width="800">
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <div v-for="question in questions" :key="question.question_id" class="mb-6">
            <v-card outlined class="pa-4">
              <v-card-title class="text-h6">
                {{question.question_text}}
              </v-card-title>
              <v-card-text>
                <!-- Rating Question -->
                <div v-if="question.question_type === 'rating'">
                  <v-rating
                    v-model="answers[question.question_id]"
                    :value="answers[question.question_id]"
                    :length="5"
                    color="amber"
                    size="32"
                    background-color="grey lighten-1"
                    empty-icon="mdi-star-outline"
                    half-icon="mdi-star-half"
                    full-icon="mdi-star"
                    hover
                    @input="() => handleAnswerClick(question.question_id)"
                  ></v-rating>
                  <div class="text-caption mt-2">
                    <span>1 = Poor</span>
                    <span class="ml-4">5 = Excellent</span>
                  </div>
                  <div class="mt-3">
                    <v-btn
                      :color="answers[question.question_id] === 'Not Sure' ? 'primary' : 'grey'"
                      :outlined="answers[question.question_id] !== 'Not Sure'"
                      @click="handleNotSureClick(question.question_id)"
                      class="not-sure-btn"
                    >
                      Not Sure
                    </v-btn>
                  </div>
                </div>
                
                <!-- Multiple Choice Question -->
                <div v-else-if="question.question_type === 'multiple_choice'">
                  <v-radio-group v-model="answers[question.question_id]" :value="answers[question.question_id]" row @change="() => handleAnswerClick(question.question_id)">
                    <v-radio
                      v-for="option in question.options"
                      :key="option"
                      :label="option"
                      :value="option"
                      class="mr-4"
                    ></v-radio>
                    <v-radio
                      label="Not Sure"
                      value="Not Sure"
                      class="mr-4"
                    ></v-radio>
                  </v-radio-group>
                </div>
                
                <!-- Button Choice Question (1-10) -->
                <div v-else-if="question.question_type === 'button_choice'">
                  <div class="button-choice-container">
                    <v-btn-toggle
                      v-model="answers[question.question_id]"
                      :value="answers[question.question_id]"
                      class="button-choice-group"
                      @change="() => handleAnswerClick(question.question_id)"
                    >
                      <v-btn
                        v-for="option in question.options"
                        :key="option"
                        :value="option"
                        color="primary"
                        outlined
                        class="choice-button"
                      >
                        {{ option }}
                      </v-btn>
                      <v-btn
                        value="Not Sure"
                        color="primary"
                        outlined
                        class="choice-button not-sure-button"
                      >
                        Not Sure
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </div>
                
                <!-- Text Question -->
                <div v-else-if="question.question_type === 'text'">
                  <v-checkbox
                    v-model="isNotSure[question.question_id]"
                    label="Not Sure"
                    color="primary"
                    @change="handleNotSureChange(question.question_id)"
                    class="mb-3"
                  ></v-checkbox>
                  <v-textarea
                    v-model="answers[question.question_id]"
                    placeholder="Please provide your answer... (Press Enter to submit)"
                    rows="3"
                    outlined
                    :disabled="isNotSure[question.question_id]"
                    @blur="() => handleTextAnswer(question.question_id)"
                    @keydown.enter.prevent="() => handleTextEnter(question.question_id)"
                  ></v-textarea>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>
</div>
</v-main>
</v-app>
</template>

<script>
import config from '@/config';

export default {
  name:'QuestionLabelling',
  title: 'Question-Based Graph Labeling',
  data() {
    return{
      questions: [],
      answers: {},
      graph_id: this.$route.params.graphid,
      user_id: this.$route.params.userid,
      username: this.$route.params.username,
      graph_image_url: '',
      start_time: null,
      dialog: false,
      count_labeled_graph: null,
      avg_spent: null,
      label_once_perc: null,
      label_twice_perc: null,
      label_thrice_perc: null,
      is_admin: null,
      congrat_dialog: false,
      rank: null,
      valid: false,
      isSubmitting: false,
      isNotSure: {},
      answeredQuestions: new Set(),
      isInitializing: true
    }
  },
  computed: {
    isFormComplete() {
      if (this.questions.length === 0) {
        return false;
      }
      const isComplete = this.questions.every(q => {
        const answer = this.answers[q.question_id];
        // Valid answers include: any non-empty string, any number > 0, or "Not Sure"
        return answer !== undefined && 
               answer !== null && 
               answer !== '' && 
               answer !== 0 && 
               answer !== false &&
               (typeof answer === 'string' && answer.trim() !== '' || 
                typeof answer === 'number' && answer > 0 ||
                answer === 'Not Sure');
      });
      
      if (isComplete) {
        console.log('Form complete!', this.answers);
      }
      return isComplete;
    }
  },
  created() {
    this.start_time = new Date().getTime();
    this.loadQuestions();
    this.loadGraphImage();
    this.loadUserStats();
  },
  methods: {
    loadQuestions() {
      fetch(`${config.API_BASE_URL}/get_questions/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(resp => resp.json())
      .then(data => {
        this.questions = data;
        // Initialize answers object and isNotSure object
        this.questions.forEach(q => {
          this.$set(this.answers, q.question_id, null);
          this.$set(this.isNotSure, q.question_id, false);
        });
        // Mark initialization as complete
        this.isInitializing = false;
      })
      .catch(err => console.log(err));
    },
    
    loadGraphImage() {
      fetch(`${config.API_BASE_URL}/get_graph_image/${this.graph_id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(resp => resp.json())
      .then(data => {
        // Prepend API base URL if the image URL is a relative path
        if (data.image_url.startsWith('/')) {
          this.graph_image_url = config.API_BASE_URL + data.image_url;
        } else {
          this.graph_image_url = data.image_url;
        }
      })
      .catch(err => console.log(err));
    },
    
    loadUserStats() {
      fetch(`${config.API_BASE_URL}/get_count_rank/${this.user_id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(resp => resp.json())
      .then(data => {
        this.count_labeled_graph = data.count;
        if (data.count >= 50 && data.count % 50 == 0) {
          this.rank = data.rank;
          this.congrat_dialog = true;
        }
      });
    },
    
    submit_answers() {
      // Prevent multiple submissions
      if (this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true;
      const end_time = new Date().getTime();
      const total_seconds = ((end_time - this.start_time) / 1000).toFixed(4);
      
       // Prepare answers data
       const answers_data = this.questions.map(q => ({
         question_id: q.question_id,
         answer: this.answers[q.question_id] ? this.answers[q.question_id].toString() : '',
         seconds_spent: total_seconds / this.questions.length, // Distribute time across questions
         is_hard: false
       }));
      
      fetch(`${config.API_BASE_URL}/label_graph`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          graph_id: this.graph_id,
          user_id: this.user_id,
          answers: answers_data
        })
      })
      .then(resp => {
        fetch(`${config.API_BASE_URL}/next_graph/${this.username}/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(resp => resp.json())
        .then(data => {
          this.$router.push({path: '/question-labelling/' + data.user_id + "/" + this.username + "/" + data.graph_id});
        });
        return resp.json();
      })
      .catch(error => {
        console.log(error);
        this.isSubmitting = false; // Reset on error
      });
    },
    
    handleNotSureClick(questionId) {
      // Handle "Not Sure" button click for rating questions
      this.$set(this.answers, questionId, 'Not Sure');
      this.handleAnswerClick(questionId);
    },
    
    handleTextAnswer(questionId) {
      // For text questions, just track the answer
      this.handleAnswerClick(questionId);
    },
    
    handleTextEnter(questionId) {
      // When Enter is pressed in text field
      if (!this.isNotSure[questionId] && this.answers[questionId] && this.answers[questionId].trim() !== '') {
        // If there's actual text content, submit the answer
        this.handleAnswerClick(questionId);
      }
    },
    
    handleNotSureChange(questionId) {
      if (this.isNotSure[questionId]) {
        // If "Not Sure" is checked, set answer to "Not Sure" and clear text
        this.$set(this.answers, questionId, 'Not Sure');
        this.handleAnswerClick(questionId);
      } else {
        // If "Not Sure" is unchecked, clear the answer
        this.$set(this.answers, questionId, null);
      }
    },
    
    handleAnswerClick(questionId = null) {
      // Update answered questions set
      if (questionId) {
        this.answeredQuestions.add(questionId);
      }
      
      // Only auto-submit if this was a real user action (not initialization)
      if (questionId && !this.isSubmitting && !this.isInitializing) {
        // Check if all questions are answered and auto-submit
        this.$nextTick(() => {
          if (this.isFormComplete) {
            console.log('Form is complete, auto-submitting...');
            // Add a small delay for better UX (user can see their selection)
            setTimeout(() => {
              this.submit_answers();
            }, 300);
          }
        });
      }
    },
    
    
    view_statistics() {
      this.dialog = true;
      fetch(`${config.API_BASE_URL}/user_statistics/${this.user_id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(resp => resp.json())
      .then(data => {
        this.is_admin = data.is_admin;
        this.avg_spent = data.avg_spent;
        this.label_once_perc = data.label_once_perc;
        this.label_twice_perc = data.label_twice_perc;
        this.label_thrice_perc = data.label_thrice_perc;
      });
    },
    
  }
}
</script>

<style scoped>
.button-choice-container {
  text-align: center;
}

.button-choice-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  margin-bottom: 8px;
}

.choice-button {
  min-width: 40px !important;
  height: 40px !important;
  font-weight: bold;
}

.choice-button.v-btn--active {
  background-color: #1976d2 !important;
  color: white !important;
}

.choice-button:hover {
  transform: scale(1.05);
  transition: transform 0.2s;
}

.not-sure-btn {
  margin-top: 8px;
}

.not-sure-button {
  background-color: #f5f5f5 !important;
  color: #666 !important;
  border: 2px dashed #999 !important;
}

.not-sure-button.v-btn--active {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
  border: 2px solid #1976d2 !important;
}
</style>